import { useQuery } from "@tanstack/react-query";
import type {
  BlogManagerAPIInterfaceInternal,
  BlogManagerFetchInterface
} from "@dealer-center/ddc-pages-blog-manager-interface";

const queryKeyBase = "ddc-pages-blog-manager";

export function useBlogManagerAPIInterface({
  searchValue
}: BlogManagerFetchInterface) {
  return useQuery({
    queryKey: [queryKeyBase, { searchValue }],
    queryFn: () => getFunction(searchValue?.trim() || ""),
    enabled: !!searchValue && searchValue.trim().length > 0,
    retry: 1,
    staleTime: 1000 * 60 * 5 // 5 minutes
  });
}

const getFunction = async (
  searchValue: string
): Promise<BlogManagerAPIInterfaceInternal[]> => {
  const res = await fetch(
    "/landing/nxlambda/blogManager/" + encodeURIComponent(searchValue)
  );
  if (res.ok) {
    return res.json();
  } else {
    throw new Error(res.statusText);
  }
};
